// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2MI_K","inner":"Footer_inner__3yyAZ"};